import { Box } from "@mui/system";
import React, { useCallback, useEffect, useState } from "react";
import { getUtcDateTime } from "../../../../lib/functions/utils.lib";
import assest from "../../../../json/assest";
import styles from "../../../../styles/components/video.module.scss";
import { Button } from "@mui/material";
import RejectionJustificationModal from "../modals/RejectionJustificationModal";
import { useMutation } from "react-query";
import { createNote, deleteNote } from "../../../../api/functions/note.api";

const DeleteStatus = ({ handleCancle, notes, data, refetchNote, onClose }) => {
  const [noteInfo, setNoteInfo] = useState();
  //   console.warn("noteInfo", noteInfo);
  //   console.warn("notes", notes);
  useEffect(() => {
    // if (notes) {
    notes?.map((note) => {
      if (note.type == "admin_delete_reason") {
        setNoteInfo(note);
      }
    });
    // }
  }, [notes]);
  const { mutate: mutateDelete } = useMutation(deleteNote, {
    onSuccess: (data) => {
      // console.warn("data", data);
      refetchNote();
      setNoteInfo(false);
    },
    onError: (error) => {
      // console.warn("error", error);
    },
  });
  return (
    <>
      <Box className={`${styles.deleteBox}`}>
        <Box className={styles.deleteBoxUP}>
          <p>
            You <b>Deleted</b> this video on{" "}
            {getUtcDateTime(
              data.video_meta.admin_updated_at ||
                data.video_meta.quality_team_updated_at
            )}
          </p>
          <Button onClick={handleCancle}>
            <img src={assest.cancelIcon} width={14} height={14} alt="" /> Cancel
          </Button>
        </Box>

        {/* <Box className={styles.deleteBoxTxt}>
            <Box className={styles.justificationBox}>
              <h5>Justification</h5>
            </Box>
            <p>Your justification will be shown here.</p>
            <p>Your justification will be shown here.</p>
          </Box> */}
        {noteInfo && (
          <>
            <Box className={styles.singleBorderDelete}></Box>

            <Box className={styles.deleteBoxTxt}>
              <Box className={styles.justificationBox}>
                <h5>Justification</h5>
              </Box>

              <Box className={styles.redRejectedBox}>
                {notes.map((note, i) => {
                  if (note.type == "admin_delete_reason") {
                    return <p key={i}>{note.note}</p>;
                  }
                })}
              </Box>
            </Box>
          </>
        )}
        <Box className={styles.crossButton}>
          <Button onClick={onClose}>
            <img src={assest.crossWhite} width={21} height={21} alt="" />
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default DeleteStatus;
